import { useTranslation } from 'react-i18next';
import { LoadingBox } from '@payler/ui-components';
import React from 'react';

export const Loader = () => {
  const { t } = useTranslation(['common']);
  return <LoadingBox text={t('common:loading')} />;
};
